import ListTlds from '@/assets/json/lista-tlds-validos.json';

export default class Email {

  errorMessage = 'Informe seu e-mail.'
  placeholder = 'Insira seu e-mail aqui'

  valid(value) {
    const errorMessageInvalid = 'E-mail inválido.'
    const errorMessageEmpty = 'Informe seu e-mail.'
    const regexEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    let result = false;

    if (regexEmail.test(value)) {
      const lastDomain = value.split('@')[1].split('.').at(-1)
      result = lastDomain ? ListTlds.includes(lastDomain.toUpperCase()) : false
      if (result === false) {
        this.errorMessage = errorMessageInvalid
      }
    }else{
      this.errorMessage = errorMessageEmpty
    }

    return result;
  }

  error(value) {
    if (value !== '') {
      return !this.valid(value)
    }

    return undefined;
  }

}
